import jwtDecode from "jwt-decode";
import Cookies from "js-cookie";

export const LOGOUT_SIGNAL_KEY = "logout-signal";

export function signalLogout() {
  try {
    window.localStorage.setItem(LOGOUT_SIGNAL_KEY, String(Date.now()));
  } catch {
    // Storage unavailable (private mode, quota) — logout must still proceed;
    // other tabs fall back to focus/route-change revalidation.
  }
}

export function isSessionSignalKey(key) {
  // key === null means another tab called localStorage.clear().
  // sessionPhoto is only ever removed during session teardown, so its
  // removal doubles as a logout nudge; revalidation re-checks the cookie
  // before acting, so a spurious nudge is harmless.
  return key === null || key === LOGOUT_SIGNAL_KEY || key === "sessionPhoto";
}

export function isTokenValid(tokenExp) {
  const time = Date.now().valueOf() / 1000;
  if (time > tokenExp) {
    return false;
  } else {
    return true;
  }
}

function clearUser() {
  window.localStorage.removeItem("sessionPhoto");
  Cookies.remove("token");
}

// Pure read of the current session: no storage side effects.
// Returns the user object for a valid token, otherwise null.
export function readUserFromToken() {
  const apiToken = Cookies.get("token");
  if (!apiToken) {
    return null;
  }

  const decodedApiToken = jwtDecode(apiToken);

  if (decodedApiToken.exp && isTokenValid(decodedApiToken.exp)) {
    return {
      name: decodedApiToken.unique_name,
      email: decodedApiToken.email ?? decodedApiToken.preferred_username,
      id: decodedApiToken.actort,
      role: Number(decodedApiToken.role),
      jobTitle: decodedApiToken.jobTitle,
      // Stamped at token mint from the single internal-domain list in UserInfoHelpers.
      // Absent on tokens issued before that claim existed, which read as not internal
      // until the user signs in again.
      isInternal: decodedApiToken.is_internal === "true",
    };
  }

  return null;
}

export function buildUser() {
  const user = readUserFromToken();
  if (!user) {
    clearUser();
  }
  return user;
}

// Gates every internal-only surface. Takes the user object rather than an email so the
// answer comes from the token claim and is never re-derived from the address here.
export function canUseBCA(user) {
  return user?.isInternal === true;
}
